var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgExamMath = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.9V18.1C19 19.1 18.2 19.9 17.2 19.9H6.8C5.8 19.9 5 19.1 5 18.1V6.9C5 6 5.4 5.3 6 4.7C6.5 4.3 7.2 4 8 4H16C17.7 4 19 5.3 19 6.9Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5999 19.3H6.6999C5.9999 19.3 5.3999 18.7 5.3999 18C5.3999 17.3 5.9999 16.7 6.6999 16.7H18.9999V17.8C18.9999 18.6 18.3999 19.3 17.5999 19.3Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3999 18.2001V19.8001C8.3999 19.9001 8.5999 20.0001 8.6999 20.0001L9.8999 19.4001L11.0999 20.0001C11.1999 20.1001 11.3999 20.0001 11.3999 19.8001V18.2001C11.3999 18.2001 11.3999 18.1001 11.2999 18.1001L8.3999 18.2001C8.3999 18.1001 8.3999 18.1001 8.3999 18.2001Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.9V16H7.2C6.6 16 6 15.5 6 14.8V4.7C6.5 4.3 7.2 4 8 4H16C17.7 4 19 5.3 19 6.9Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8 11.9999H9.2C8.8 11.9999 8.5 11.5999 8.5 11.1999V7.6999C8.5 7.2999 8.8 6.8999 9.3 6.8999H15.9C16.3 6.8999 16.7 7.1999 16.7 7.6999V11.1999C16.6 11.5999 16.2 11.9999 15.8 11.9999Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5C9.5 8.2 9.7 8 10 8H15.1C15.4 8 15.6 8.2 15.6 8.5C15.6 8.8 15.4 9 15.1 9H10C9.7 9 9.5 8.7 9.5 8.5Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5C9.5 10.2 9.7 10 10 10H15.1C15.4 10 15.6 10.2 15.6 10.5C15.6 10.8 15.4 11 15.1 11H10C9.7 11 9.5 10.8 9.5 10.5Z",
    fill: "url(#paint5_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.1175,
    y1: 4.3584,
    x2: 6.2142,
    y2: 18.7746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.0274,
    y1: 13.4494,
    x2: 11.5301,
    y2: 19.6034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 9.8995,
    y1: 18.0274,
    x2: 9.9599,
    y2: 20.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3948,
    stopColor: "#204AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 16.3198,
    y1: 4.9156,
    x2: 9.7357,
    y2: 14.3469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 13.6041,
    y1: 6.1502,
    x2: 12.1871,
    y2: 9.1416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 13.6041,
    y1: 8.165,
    x2: 12.1871,
    y2: 11.1564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExamMath, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ExamMath.cbaff3bd.svg";
export { ForwardRef as ReactComponent };